export default __webpack_public_path__ + "static/media/(78).16f40726.jpg";